import { type IMetaTotal } from '@/types/IBannerData';
import { type IErrorData } from '@/utils/getErrorData';
// import { isError } from '@/utils/typeguards/isError';
// import { hasResponse } from '@/utils/typeguards/hasResponse';
import { createAsyncThunk } from '@reduxjs/toolkit';
// import { getQuestions, updateQuestion } from '@/api/questionApi';
import { type IQuestion } from '@/types/IReviewsAndQuestion';
import { mockQuestions } from '@/mocks/reviewsAndQuestions/questionsMocks';

export const getQuestionsThunk = createAsyncThunk<
  { items: IQuestion[]; meta: IMetaTotal },
  { limit: number; offset: number },
  { rejectValue: IErrorData }
>(
  'questions/getQuestionsThunk',
  async ({ limit, offset }, { rejectWithValue }) => {
    try {
      // TODO: Убрать моки, когда будет готов бэкенд
      const items = mockQuestions.slice(offset, offset + limit);
      const meta = { total: mockQuestions.length };

      return { items, meta };

      // Оригинальный код (закомментирован):
      // const data = await getQuestions(limit, offset);
      // if (isError(data)) {
      //   return rejectWithValue(data);
      // }
      // if (!hasResponse<{ items: IQuestion[]; meta: IMetaTotal }>(data)) {
      //   return rejectWithValue({ message: 'Некорректный ответ сервера' });
      // }
      // return {
      //   items: data.response.items,
      //   meta: data.response.meta
      // };
    } catch {
      return rejectWithValue({ message: 'Ошибка при получении вопросов' });
    }
  }
);

export const updateQuestionThunk = createAsyncThunk<
  IQuestion,
  {
    questionId: number;
    status: 'approved' | 'pending' | 'rejected';
    answer?: string;
  },
  { rejectValue: IErrorData }
>(
  'questions/updateQuestionThunk',
  async ({ questionId, status, answer }, { rejectWithValue }) => {
    try {
      // TODO: Убрать моки, когда будет готов бэкенд
      const questionIndex = mockQuestions.findIndex(
        (question) => question.id === questionId
      );
      if (questionIndex === -1) {
        return rejectWithValue({ message: 'Вопрос не найден' });
      }
      mockQuestions[questionIndex].status = { status };
      if (answer !== undefined) {
        mockQuestions[questionIndex].answers =
          mockQuestions[questionIndex].answers ?? [];
        mockQuestions[questionIndex].answers.push({
          id: Date.now(), // Простой ID для мока
          text: answer,
          user: {
            id: 999,
            phone: 'admin',
            roles: ['ROLE_ADMIN'],
            email: 'admin@example.com',
            name: 'Админ',
            email_confirmed: true,
            phone_confirmed: true,
            favouriteProducts: [],
            accountDeliveryAddresses: [],
            amount_purchases: 0,
            amount_purchased: 0,
            percent_purchased: 0
          }, // Мок админа
          status: { status: 'approved' },
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        });
      }
      return mockQuestions[questionIndex];

      // Оригинальный код (закомментирован):
      // const requestData: {
      //   status: 'approved' | 'pending' | 'rejected';
      //   answer?: string;
      // } = { status };
      // if (answer !== undefined) {
      //   requestData.answer = answer;
      // }
      // const data = await updateQuestion(questionId, requestData);
      // if (isError(data)) {
      //   return rejectWithValue(data);
      // }
      // if (!hasResponse<IQuestion>(data)) {
      //   return rejectWithValue({ message: 'Некорректный ответ сервера' });
      // }
      // return data.response;
    } catch {
      return rejectWithValue({ message: 'Ошибка при обновлении вопроса' });
    }
  }
);

export const updateQuestionStatusThunk = createAsyncThunk<
  IQuestion,
  {
    questionId: number;
    status: 'approved' | 'pending' | 'rejected';
  },
  { rejectValue: IErrorData }
>(
  'questions/updateQuestionStatusThunk',
  async ({ questionId, status }, { rejectWithValue }) => {
    try {
      // TODO: Убрать моки, когда будет готов бэкенд
      const questionIndex = mockQuestions.findIndex(
        (question) => question.id === questionId
      );
      if (questionIndex === -1) {
        return rejectWithValue({ message: 'Вопрос не найден' });
      }
      mockQuestions[questionIndex].status = { status };
      return mockQuestions[questionIndex];
    } catch {
      return rejectWithValue({
        message: 'Ошибка при обновлении статуса вопроса'
      });
    }
  }
);

export const updateQuestionAnswerStatusThunk = createAsyncThunk<
  IQuestion,
  {
    questionId: number;
    answerId: number;
    status: 'approved' | 'pending' | 'rejected';
  },
  { rejectValue: IErrorData }
>(
  'questions/updateQuestionAnswerStatusThunk',
  async ({ questionId, answerId, status }, { rejectWithValue }) => {
    try {
      // TODO: Убрать моки, когда будет готов бэкенд
      const questionIndex = mockQuestions.findIndex(
        (question) => question.id === questionId
      );
      if (questionIndex === -1) {
        return rejectWithValue({ message: 'Вопрос не найден' });
      }
      const question = mockQuestions[questionIndex];
      const answerIndex =
        question.answers?.findIndex((answer) => answer.id === answerId) ?? -1;
      if (answerIndex === -1) {
        return rejectWithValue({ message: 'Ответ не найден' });
      }
      if (question.answers !== undefined) {
        question.answers[answerIndex].status = { status };
      }
      return mockQuestions[questionIndex];
    } catch {
      return rejectWithValue({
        message: 'Ошибка при обновлении статуса ответа'
      });
    }
  }
);

export const createQuestionAnswerThunk = createAsyncThunk<
  IQuestion,
  {
    questionId: number;
    text: string;
  },
  { rejectValue: IErrorData }
>(
  'questions/createQuestionAnswerThunk',
  async ({ questionId, text }, { rejectWithValue }) => {
    try {
      // TODO: Убрать моки, когда будет готов бэкенд
      const questionIndex = mockQuestions.findIndex(
        (question) => question.id === questionId
      );
      if (questionIndex === -1) {
        return rejectWithValue({ message: 'Вопрос не найден' });
      }
      const question = mockQuestions[questionIndex];
      if (question.answers === undefined) {
        question.answers = [];
      }
      question.answers.push({
        id: Date.now(),
        text,
        user: {
          id: 999,
          phone: 'admin',
          roles: ['ROLE_ADMIN'],
          email: 'admin@example.com',
          name: 'Администратор',
          email_confirmed: true,
          phone_confirmed: true,
          favouriteProducts: [],
          accountDeliveryAddresses: [],
          amount_purchases: 0,
          amount_purchased: 0,
          percent_purchased: 0
        },
        status: { status: 'approved' },
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      });
      return mockQuestions[questionIndex];
    } catch {
      return rejectWithValue({ message: 'Ошибка при создании ответа' });
    }
  }
);
